import React from 'react';
import * as S from './filters.styles';
import AirlineRow from './airline-row';

const FamousFor = props => {
  const { updateFilter, handleResetIndividualFilter, famousForFilters, famousFor } = props;
  return (
    <>
      <div className="flexCol">
        <div className="padB10 flexCol">
          <div className="dF justifyBetween quicksand">
            <div className="black fb font14  quicksand">Famous For</div>
            <S.Reset
              clickable={famousForFilters.length}
              onClick={() => handleResetIndividualFilter('famousFor')}
            >
              reset
            </S.Reset>
          </div>
          <div className="grey font11 padT5"></div>
        </div>
        <div className="flexCol">
          {famousFor.map((location, index) => {
            return (
              <AirlineRow
                index={index}
                updateFilter={updateFilter}
                location={location}
                filterType="famousFor"
                isChecked={famousForFilters.includes(location)}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};
export default FamousFor;
